
import * as React from 'react';
import * as ReactDOM from 'react-dom';

import KendoBaseComponent, { KendoWidgetProps } from '@progress/kendo-base-component-react-wrapper';

export interface ToolBarProps extends KendoWidgetProps, kendo.ui.ToolBarOptions {
    children?: React.ReactNode;
}

export default class ToolBar extends KendoBaseComponent<ToolBarProps, {}> {
    componentDidMount(): void {
        const domNode = this.domNode;
        const { children, widgetRef, ...props } = this.props;

        if (domNode) {
            this.widgetInstance = new kendo.ui.ToolBar(domNode as Element, (props as kendo.ui.ToolBarOptions));
            super.componentDidMount();
        }
    }

    render(): any {
        if (this.didMount) {
            const { children, widgetRef, ...props } = this.props;

            this.widgetInstance.setOptions(props);
        }

        const domChild = React.Children
            .toArray(this.props.children)
            .filter((child: React.ReactElement<any>) => child && (child.type === 'div'))
            .shift();

        return domChild
            ? React.cloneElement(domChild, { ...domChild.props, ref: this.elementRef })
            : <div ref={this.elementRef} />;
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-buttons-react-wrapper/src/toolbar/index.tsx